import { useState, type ReactNode } from 'react';
import { ConfirmButtons } from './creator-delete-confirm';

type Props = {
  onConfirm: (reason: string) => void;
  onCancel: () => void;
  isPending: boolean;
};

function ReasonInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}): ReactNode {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value.slice(0, 200))}
      placeholder="Motivo (opcional)"
      rows={2}
      className="w-full rounded-md border border-white/[0.06] bg-surface-elevated p-sm text-xs text-text-primary placeholder:text-text-tertiary focus:border-brand-red focus:outline-none"
    />
  );
}

// Confirm modal específico para Fase B: el collector elimina voluntariamente
// un lead que la IA rechazó. Distinto de la papelera admin (deleted_at): el
// lead desaparece de las vistas del collector pero queda auditable via
// user_deleted_at.
export function CreatorUserDeleteConfirm({
  onConfirm,
  onCancel,
  isPending,
}: Props): ReactNode {
  const [reason, setReason] = useState('');
  return (
    <div className="flex flex-col gap-sm border-t border-white/[0.06] pt-base">
      <p className="text-xs text-text-secondary">
        Vas a eliminar este lead de tus listas. Si crees que la IA se equivoca,
        usa &quot;Apelar&quot; en lugar de eliminar.
      </p>
      <ReasonInput value={reason} onChange={setReason} />
      <ConfirmButtons
        onCancel={onCancel}
        onConfirm={() => onConfirm(reason)}
        isPending={isPending}
        label="Eliminar lead"
        variant="danger"
      />
    </div>
  );
}
